import request from "axios";
import {UserResponse} from "../pages/account/LoginPage";
import {getAuthApiHost} from "../config";

export const logIn = async ({email, password}: {
  email: string,
  password: string
}): Promise<undefined> => {
  return await request.post(getAuthApiHost() + "/auth/tokens", {email, password}, {withCredentials: true})
}

export const logOut = async (): Promise<void> => {
  return await request.delete(getAuthApiHost() + "/auth/tokens", {withCredentials: true})
}

// TO DELETE
export const AUTH_TOKEN_KEY = "authToken";
export const fetchUser = async (): Promise<UserResponse | null> => {

  const tokenMaybe = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!tokenMaybe) {
    return Promise.resolve(null);
  }
  const parsedToken = `${JSON.parse(tokenMaybe)}`;
  return (await request
    .get(getAuthApiHost() + "/identity/user",
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": parsedToken
        }
      })).data;
};

export const registerEmail = async (email: string): Promise<void> => {
  return (await request
    .post(getAuthApiHost() + "/auth/users",
      {email: email}));
};

export const registerPasswordReset = async (email: string): Promise<void> => {
  return (await request
    .post(getAuthApiHost() + "/auth/passwords/reset-request",
      {email: email},
    ));
};

export const updatePassword = async ({password, token}: { password: string, token: string }): Promise<void> => {
  return (await request
    .post(
      getAuthApiHost() + "/auth/passwords/set",
      {password, token},
    ))
}

export const createAccount = async (email: string, password: string, displayName: string, timeBasedToken: string): Promise<void> => {
  return (await request
    .post(
      getAuthApiHost() + "/identity/user",
      {email: email, password: password, displayName: displayName, timeBasedToken: timeBasedToken},
    ))
}